import MuiButton from './button'
import MuiCard from './card'
import MuiChip from './chip'
import MuiDialog from './dialog'
import MuiInput from './input'
import MuiMisc from './misc'
import MuiTable from './table'

const Overrides = () =>
  Object.assign(MuiButton(), MuiCard(), MuiInput(), MuiChip(), MuiTable(), MuiDialog(), MuiMisc())

export default Overrides
